import { useOrder } from "@/context";
import type { TagHue } from "@/components/molecules/Tag/interface";

const GREEN_WORDS = ["aprovado", "sucesso"];

export function useHistorico() {
  const { conversation } = useOrder();

  function extractLastWord(subject: string): string {
    const raw = subject.trim().split(/\s+/).pop() ?? "";
    const clean = raw.replace(/[^a-záéíóúãõâêôçA-ZÁÉÍÓÚÃÕÂÊÔÇ]/g, "");
    return clean.charAt(0).toUpperCase() + clean.slice(1).toLowerCase();
  }

  function getSubjectHue(subject: string): TagHue {
    const lastWord = extractLastWord(subject).toLowerCase();
    return GREEN_WORDS.includes(lastWord) ? "green" : "yellow";
  }

  return { conversation, getSubjectHue, extractLastWord };
}
